module.exports = __webpack_public_path__ + "Roboto-Bold.e31fcf1885e371e19f57.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Bold.ttf
// module id = 298
// module chunks = 2